function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Information Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M9.4676,0.0001 C14.6949159,0.0001 18.9326,4.23713111 18.9326,9.4641 C18.9326,14.6910689 14.6949159,18.9281 9.4676,18.9281 C4.24112087,18.9281 0.0036,14.6909056 0.0036,9.4641 C0.0036,4.23729435 4.24112087,0.0001 9.4676,0.0001 Z M9.4676,1.0001 C4.79338837,1.0001 1.0036,4.78959635 1.0036,9.4641 C1.0036,14.1386036 4.79338837,17.9281 9.4676,17.9281 C14.1426656,17.9281 17.9326,14.1387496 17.9326,9.4641 C17.9326,4.78945036 14.1426656,1.0001 9.4676,1.0001 Z M9.8955,6.6184 C10.1716424,6.6184 10.3955,6.84225763 10.3955,7.1184 L10.3955,7.1184 L10.3946,13.3251 L11.5245,13.3254 C11.7699599,13.3254 11.9741084,13.5022752 12.0164443,13.7355244 L12.0245,13.8254 C12.0245,14.1015424 11.8006424,14.3254 11.5245,14.3254 L11.5245,14.3254 L8.1035,14.3254 C7.82735763,14.3254 7.6035,14.1015424 7.6035,13.8254 C7.6035,13.5492576 7.82735763,13.3254 8.1035,13.3254 L8.1035,13.3254 L9.3946,13.3251 L9.3955,7.6184 L8.1035,7.6184 C7.82735763,7.6184 7.6035,7.39454237 7.6035,7.1184 C7.6035,6.84225763 7.82735763,6.6184 8.1035,6.6184 L8.1035,6.6184 Z M9.624,4.2942 C9.969,4.2942 10.249,4.5742 10.249,4.9192 C10.249,5.2642 9.969,5.5442 9.624,5.5442 C9.279,5.5442 9,5.2642 9,4.9192 C9,4.5742 9.279,4.2942 9.624,4.2942 Z",
  id: "information-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "information-Icon/Global/Information",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "information-Group-9",
  transform: "translate(2.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "information-Swatches/Midnight",
  transform: "translate(0.996000, 0.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "information-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#information-path-1"
}))));

var SvgInformation = function SvgInformation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInformation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/information.b968c1c0.svg";
export { ForwardRef as ReactComponent };